<template>
  <div class="mapping h-100 d-flex flex-column flex-1" v-if="farm">
    <template v-if="!!rosMap && rosMap.scene.scaleX === 1">
      <div
        style="z-index: 99; left: 0"
        class="loader position-fixed top-0 start-0 bg-white h-100 w-100 opacity-90 d-flex justify-content-center align-items-center"
      >
        <div class="d-flex align-items-center">
          <i class="material-icons">hourglass_empty</i>
          <strong>{{$t('global.loading')}}</strong>
        </div>
      </div>
    </template>
    <div class="btn-toolbar" role="toolbar" aria-label="Toolbar with button groups">
      <div class="btn-group mr-2" role="group" aria-label="First group">
        <button type="button" class="btn btn-primary" @click="sendCommand('Start')">
          <i class="material-icons">play_arrow</i>
        </button>
        <button type="button" class="btn btn-primary" @click="sendCommand('Stop')">
          <i class="material-icons">pause</i>
        </button>
        <button type="button" class="btn btn-primary" @click="sendCommand('Kill')">
          <i class="material-icons">stop</i>
        </button>
        <button type="button" class="btn btn-primary" @click="sendCommand('Restart')">
          <i class="material-icons">replay</i>
        </button>
        <button type="button" class="btn btn-primary" @click="setHome()">
          <i class="material-icons">home</i>
        </button>
      </div>

      <div v-show="farm.isMapped" class="btn-group ml-auto" role="group" aria-label="Second group">
        <router-link
          class="nav-link btn btn-secondary"
          :to="{ name: 'Harvest', params: { id: farm.id } }"
        >{{ $t("global.harvest")}}</router-link>
      </div>
    </div>
    <div>{{ $t("global.state")}}: {{mappingState}}</div>
    <div class="map">
      <i
        v-if="!!rosMap && !!farm.home"
        class="material-icons flare"
        :style="{ left: rosToGlobal(rosMap, {x: farm.home[0], y: farm.home[1]}).x - 12 + 'px', top: rosToGlobal(rosMap, {x: farm.home[0], y: farm.home[1]}).y - 10 + 'px' }"
      >home</i>
      <Map v-on:coordinates="saveHome" name="mapping" @initMap="initMap" />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState, mapActions } from "vuex";
import Map from "@/components/Map.vue";
import RosService from "@/services/RosService.js";

export default {
  name: "Mapping",
  props: ["id"],
  data() {
    return {
      farm: null,
      rosMap: null
    };
  },
  created() {
    if (this.farms) {
      this.farm = this.farms.find(farm => farm.id === parseInt(this.id));
      if (this.farm) {
        RosService.sendMappingCommand("Enter", this.farm.id);
      }
    }
  },
  components: {
    Map
  },
  computed: {
    ...mapState({
      mappingState: state => state.chat.diagnostics.mappingState,
      gotoCommand: state => state.chat.diagnostics.gotoCommand,
      confirmationRequired: state => state.confirmationRequired,
      farms: state => state.farms.all
    })
  },
  methods: {
    initMap(viewer) {
      this.rosMap = viewer;
    },
    saveHome(values) {
      if (this.gotoCommand != "SetHome") {
        return;
      }
      this.farm.homeX = this.globalToRos(this.rosMap, values.x);
      this.farm.homeY = this.globalToRos(this.rosMap, values.y);
      let today = new Date();
      let date =
        today.getDate() +
        "/" +
        (today.getMonth() + 1) +
        "/" +
        today.getFullYear();
      this.farm.mapDate = date;
      this.farm.isMapped = true;

      this.$store.dispatch("farms/updateFarm", this.farm);
      this.$store.dispatch("chat/setAttribute", { gotoCommand: null });
    },
    setHome() {
      if (!this.confirmationRequired || confirm(this.$t("global.set_home"))) {
        this.$store.dispatch("chat/setAttribute", { gotoCommand: "SetHome" });
      }
    },
    sendCommand(command) {
      if (
        !this.confirmationRequired ||
        confirm(this.$t("global.confirmation_question"))
      ) {
        RosService.sendMappingCommand(command);
      }
    },
    toPercentX(x) {
      return Math.floor((x / 350) * 100);
    },
    toPercentY(y) {
      return Math.floor((y / 500) * 100);
    },
    toPixelsX(x) {
      return Math.floor((x * 350) / 100);
    },
    toPixelsY(y) {
      return Math.floor((y * 500) / 100);
    },
    globalToRos(viewer, x, y) {
      var rosX = (x - viewer.scene.x) / viewer.scene.scaleX;
      var rosY = (viewer.scene.y - y) / viewer.scene.scaleY;
      return new ROSLIB.Vector3({
        x: rosX,
        y: rosY
      });
    },
    rosToGlobal(viewer, pos) {
      var x = pos.x * viewer.scene.scaleX + viewer.scene.x;
      var y = -(viewer.scene.scaleY * pos.y - viewer.scene.y); // Flip Y coordinates
      return {
        x: x,
        y: y
      };
    }
  }
};
</script>
<style scoped>
canvas {
  border: solid 1px blue;
}
.flare {
  position: absolute;
  z-index: 10;
  color: red;
  left: 0;
  top: 0;
}
.map {
  padding-top: 5px;
  position: relative;
  min-height: 100%;
}
.material-icons {
  line-height: 36px;
}
</style>